import { cn } from '~/lib/utils';
import { useStore } from '~/store';
import { enterMatte, enterSprite, selectCanCommit } from './actions';

const STEPS = [
  { id: 'matte', label: 'Matte' },
  { id: 'sprite', label: 'Sprite' },
] as const;

/** Segmented workflow control between matte and sprite steps. */
export function StepSwitcher() {
  const step = useStore((s) => s.workflow.step);
  const canCommit = useStore(selectCanCommit);

  const onClick = (id: 'matte' | 'sprite') => {
    if (id === step) return;
    if (id === 'matte') enterMatte();
    else enterSprite();
  };

  return (
    <nav
      aria-label="Workflow step"
      className="flex items-center gap-0.5 rounded-md border bg-muted/30 p-0.5 text-xs"
    >
      {STEPS.map((stepOption) => {
        const active = stepOption.id === step;
        const disabled = stepOption.id === 'sprite' && !canCommit && !active;
        return (
          <button
            key={stepOption.id}
            type="button"
            onClick={() => onClick(stepOption.id)}
            disabled={disabled}
            aria-current={active ? 'step' : undefined}
            className={cn(
              'rounded px-2 py-1 font-medium transition-colors',
              active
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
              disabled && 'cursor-not-allowed opacity-40 hover:text-muted-foreground',
            )}
            title={disabled ? 'Pick at least one background color before continuing.' : undefined}
          >
            {stepOption.label}
          </button>
        );
      })}
    </nav>
  );
}
